import React from "react";
import {useTranslation} from "react-i18next"

import {IonItem, IonItemSliding, IonLabel, IonList, IonText} from "@ionic/react"

import {DataSource as ItemType}    from "../../../types/DataSource"
import DataSourceSync from "../../../types/DataSourceSync";
import {useLockingSystems} from "../../../contexts/LockingSystemContext";

import ListItem              from "./ListItem";
import ItemSegmentListHeader from "../../common/Headers/ItemSegmentListHeader";


interface props {
    item: ItemType
}

const List: React.FC<props> = ({ item }) => {

    const { t } = useTranslation()
    const {
        selectedItem: selectedLockingSystem
    } = useLockingSystems()


    const lockingSystemSyncState = selectedLockingSystem()?.lockingSystemSyncState;

    const listDataSourceSyncs = (dataSourceSync: DataSourceSync[]) => {
        if (dataSourceSync.length === 0) {
            return (
                <IonItem className="ion-text-center">
                    <IonLabel className="ion-text-wrap">
                        {t('data-sources.no_data_source_sync_for_data_source')}
                    </IonLabel>
                </IonItem>
            )
        }

        return item.dataSourceSyncs?.map((dataSourceSync: DataSourceSync) => {
            return (
                <IonItemSliding key={"item-sliding-data-source-sync-" + dataSourceSync.id}>
                    <ListItem
                        dataSource={item}
                        dataSourceSync={dataSourceSync}
                        disabled={!!lockingSystemSyncState?.lockedAt}
                    />
                </IonItemSliding>
            )
        })
    }

    return (
        <>
            {lockingSystemSyncState?.lockedAt &&
                <div className="ion-padding message message-info">
                    <IonText>
                        {t('common.sync_in_progress')}
                    </IonText>
                </div>
            }
            <IonList lines="full" className="maxWidth">
                <ItemSegmentListHeader
                    title={item?.name || '-'}
                    subTitle={item?.dataSourceType?.name || '-'}
                />
                {listDataSourceSyncs(item.dataSourceSyncs || [])}
            </IonList>
        </>
    )
}

export default List